export function getImagePath(relativePath) {
  // Remove leading slashes
  relativePath = relativePath?.replace(/^\/+(http|https):\/\//i, "$1://");

  const isAbsolute = /^(http|https):\/\//i.test(relativePath);
  return isAbsolute
    ? relativePath
    : `${window.location.origin}/${relativePath?.replace(/^\/+/, "")}`;
}